import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type ReorderProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const Reorder = ({
  title = 'Reorder',
  viewBox = '0 0 24 24',
  ...props
}: ReorderProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.486 8.948a1.37 1.37 0 0 0 0-1.937L12.14 2.666 7.798 7.011l-.055.058a1.37 1.37 0 0 0 .055 1.88l.059.054a1.37 1.37 0 0 0 1.879-.055l2.406-2.407 2.408 2.407.058.055a1.37 1.37 0 0 0 1.879-.055Zm-.076 6.178a1.37 1.37 0 0 1 0 1.938l-4.344 4.344-4.345-4.344-.055-.059a1.37 1.37 0 0 1 .055-1.879l.06-.055a1.37 1.37 0 0 1 1.878.055l2.407 2.408 2.407-2.408.058-.055a1.37 1.37 0 0 1 1.88.055Z"
      fill="currentColor"
    />
  </CreateIconComponent>
);

export default Reorder;
